(() => {
  const dialog = document.getElementById('pdl-seasonal-popup');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const editor = dialog.dataset.designMode === 'true';
  const firstVisit = dialog.dataset.firstVisit === 'true';
  const repeatHours = Math.max(0, Number(dialog.dataset.repeatHours) || 0);
  const interval = repeatHours * 60 * 60 * 1000;
  const previewTheme = window.Shopify?.theme?.role === 'unpublished' ? `:preview:${window.Shopify.theme.id}` : '';
  const campaign = dialog.dataset.campaign || 'seasonal';
  const key = `pdl:seasonal-popup:seen:${campaign}${previewTheme}`;
  const cookieName = encodeURIComponent(key);
  let memorySeen = '';
  const isRecent = value => {
    if (!value) return false;
    if (!interval) return value === '1';
    const seenAt = Number(value);
    return Number.isFinite(seenAt) && seenAt > 0 && Date.now() - seenAt < interval;
  };
  const wasSeen = () => {
    if (isRecent(memorySeen)) return true;
    try { if (isRecent(window.localStorage.getItem(key))) return true; } catch {}
    const cookie = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(`${cookieName}=`));
    return cookie ? isRecent(cookie.slice(cookieName.length + 1)) : false;
  };
  const markSeen = () => {
    if (editor || !firstVisit) return;
    memorySeen = interval ? String(Date.now()) : '1';
    try { window.localStorage.setItem(key, memorySeen); } catch {}
    document.cookie = `${cookieName}=${memorySeen}; Max-Age=${interval ? Math.ceil(interval / 1000) : 34560000}; Path=/; SameSite=Lax; Secure`;
  };
  if (!editor && firstVisit && wasSeen()) return;
  let timer;
  let previousOverflow;
  let previousFocus;
  const restore = () => {
    if (previousOverflow !== undefined) {
      document.documentElement.style.overflow = previousOverflow;
      previousOverflow = undefined;
    }
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const close = () => { if (dialog.open) dialog.close(); };
  dialog.querySelectorAll('[data-pdl-popup-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  dialog.addEventListener('close', restore);
  window.addEventListener('pagehide', () => { clearTimeout(timer); close(); });
  window.addEventListener('storage', event => {
    if (event.key === key && isRecent(event.newValue)) { clearTimeout(timer); close(); }
  });
  const open = () => {
    if (!dialog.isConnected || (!editor && firstVisit && wasSeen())) return;
    if (document.visibilityState === 'hidden' || document.querySelector('dialog[open]')) {
      timer = window.setTimeout(open, 1000);
      return;
    }
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    markSeen();
    dialog.querySelector('.pp-close')?.focus({ preventScroll: true });
  };
  timer = window.setTimeout(open, editor ? 300 : Math.max(0, Number(dialog.dataset.delay) || 0) * 1000);
})();
